<template>
  <div :style="{ cursor, userSelect}" class="vue-splitter-container clearfix" @mouseup="onMouseUp" @mousemove="onMouseMove">

    <pane class="splitter-pane splitter-paneL" :split="split" :style="{ [type]: percent+'%'}">
      <slot name="paneL"></slot>
    </pane>

    <resizer :style="{ [resizeType]: percent+'%' ,'display':percent>0?'inherit':'none'}" :split="split" @mousedown.native="onMouseDown" @click.native="onClick"></resizer>

    <pane class="splitter-pane splitter-paneR" :split="split" :style="{ [type]: 100-percent+'%'}">
      <slot name="paneR"></slot>
    </pane>
    <div style="position:absolute;top:0;left:0;bottom:0;right:0" v-show="active"></div>
  </div>
</template>

<script>
  import Resizer from './resizer.vue';
  import Pane from './pane.vue';

  export default {
    name: 'splitPane',
    components: { Resizer, Pane },
    props: {
      minPercent: {
        type: Number,
        default: 10
      },
      defaultPercent: {
        type: Number,
        default:30
      },
      defaultSize:Number,
      split: {
        validator(value) {
          return ['vertical', 'horizontal'].indexOf(value) >= 0
        },
        default:'vertical'
      }
    },
    computed: {
      userSelect() {
        return this.active ? 'none' : ''
      },
      cursor() {
        return this.active ? 'col-resize' : ''
      }
    },
    data() {
      return {
        active: false,
        hasMoved: false,
        showMask:false,
        height: null,
        percent: this.defaultPercent,
        type: this.split === 'vertical' ? 'width' : 'height',
        resizeType: this.split === 'vertical' ? 'left' : 'top'
      }
    },
    mounted(){

      if (this.defaultSize) {
        this.computePercentage(this.defaultSize);
      }
    },
    methods: {
      computePercentage(size){
        if(!size)return;
        let totalSize=$(this.$el).width();
        this.percent=size*100/totalSize
      },
      onClick() {
        if (!this.hasMoved) {
          //this.percent = 50;
          this.$emit('resize');
        }
      },
      onMouseDown() {
        this.active = true;
        this.hasMoved = false;
      },
      onMouseUp() {
        this.active = false;
      },
      onMouseMove(e) {
        if (e.buttons === 0 || e.which === 0) {
          this.active = false;
        }
        if (this.active) {
          let offset = 0;
          let target = e.currentTarget;
          if (this.split === 'vertical') {
            while (target) {
              offset += target.offsetLeft;
              target = target.offsetParent;
            }
          } else {
            while (target) {
              offset += target.offsetTop;
              target = target.offsetParent;
            }
          }

          const currentPage = this.split === 'vertical' ? e.pageX : e.pageY;
          const targetOffset = this.split === 'vertical' ? e.currentTarget.offsetWidth : e.currentTarget.offsetHeight;
          const percent = Math.floor(((currentPage - offset) / targetOffset) * 10000) / 100;
          if (percent > this.minPercent && percent < 100 - this.minPercent) {
            this.percent = percent;
          }
          this.$emit('resize',this.percent);
          this.hasMoved = true;
        }
      }
    },
    watch: {
      defaultPercent:function(val){
        this.percent=val
      }
    }


  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/split-panel/index.vue